module.exports = __webpack_public_path__ + "static/media/blue_pin_drop.d80538ad.svg";